<template>
  <el-form-item>
    <template #label>
      <span
        >{{ i18nt('designer.setting.fileTypes') }}
        <el-tooltip effect="light" :content="i18nt('designer.setting.fileTypesHelp')"> <i class="el-icon-info"></i></el-tooltip>
      </span>
    </template>
    <el-select multiple allow-create filterable default-first-option v-model="optionModel.fileTypes" style="width: 100%">
      <el-option v-for="(ft, ftIdx) in uploadPictureTypes" :key="ftIdx" :label="ft.label" :value="ft.value"> </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
import { reactive, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';

export default {
  name: 'm-picture-upload-fileTypes-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();

    const data = reactive({
      uploadPictureTypes: [
        { label: 'jpg', value: 'jpg' },
        { label: 'jpeg', value: 'jpeg' },
        { label: 'png', value: 'png' },
        { label: 'gif', value: 'gif' },
      ],
    });

    return {
      i18nt,
      ...toRefs(props),
      ...toRefs(data),
    };
  },
};
</script>

<style scoped></style>
